import vueCookies from 'vue-cookies';

export function setProcessWindowList(id) {
  const openedWindows = JSON.parse(vueCookies.get('opened-process-windows')) || [];
  if (!openedWindows.includes(id)) {
    openedWindows.push(id);
    vueCookies.set('opened-process-windows', JSON.stringify(openedWindows), '12h');
  }
}

export function deleteProcessWindow(id) {
  let openedWindows = JSON.parse(vueCookies.get('opened-process-windows')) || [];
  openedWindows = openedWindows.filter((element) => element !== id);
  vueCookies.set('opened-process-windows', JSON.stringify(openedWindows), '12h');
  if (openedWindows.length === 0) {
    localStorage.setItem('processSharedData', JSON.stringify({}));
  }
}

export function isEmptyProcessWindowList() {
  const openedWindows = JSON.parse(vueCookies.get('opened-process-windows')) || [];
  return openedWindows.length === 0;
}

export function changeProcessShareFlag(type) {
  const sharedData = JSON.parse(localStorage.getItem('processSharedData')) || {};
  localStorage.setItem(
    'processSharedData',
    JSON.stringify({ ...sharedData, ...{ [type]: false } })
  );
  localStorage.setItem('processSharedData', JSON.stringify({ ...sharedData, ...{ [type]: true } }));
  localStorage.setItem(
    'processSharedData',
    JSON.stringify({ ...sharedData, ...{ [type]: false } })
  );
}

export function compareJson(json1, json2, moreKey = '') {
  const differences = {};
  if (!json1 || !json2) return differences;
  for (const key in json1) {
    if (json2.hasOwnProperty(key)) {
      const value1 = json1[key];
      const value2 = json2[key];

      if (Array.isArray(value1) && Array.isArray(value2) && value1.length != value2.length) {
        differences[key] = value1;
        continue;
      }

      if (typeof value1 !== typeof value2) {
        differences[key] = value1;
        continue;
      }

      if (Array.isArray(value1) && Array.isArray(value2)) {
        const subDifferences = compareJson(value1, value2, moreKey);
        if (Object.keys(subDifferences).length > 0) {
          differences[key] = subDifferences;
        }
        continue;
      }

      if (typeof value1 === 'object' && typeof value2 === 'object') {
        const subDifferences = compareJson(value1, value2, moreKey);
        if (Object.keys(subDifferences).length > 0) {
          if (moreKey) subDifferences[moreKey] = value1[moreKey];
          differences[key] = subDifferences;
        }
        continue;
      }

      if (value1 !== value2) {
        differences[key] = value1;
      }
    }
  }
  return differences;
}

export function compareTableData(data1, data2, primaryKey) {
  const differences = {};
  if (!primaryKey) return differences;

  const dataNew = [];
  const dataRemove = [];
  let dataUpdate = [];

  const dataTarget = [];
  const dataOrigin = [];

  data2.forEach((e) => {
    const existsInData1 = data1.some((item) => item[primaryKey] === e[primaryKey]);
    if (!existsInData1) {
      dataNew.push(e);
    } else {
      dataTarget.push(e);
    }
  });

  data1.forEach((e) => {
    const existsInData2 = data2.some((item) => item[primaryKey] === e[primaryKey]);
    if (!existsInData2) {
      dataRemove.push(e);
    } else {
      dataOrigin.push(e);
    }
  });

  // console.log("Data for compare : ", dataTarget, dataOrigin);
  // console.log("Data will add : ", dataNew);
  // console.log("Data will remove : ", dataRemove);

  dataUpdate = compareJson(dataTarget, dataOrigin, primaryKey);

  const updateList = [];
  Object.keys(dataUpdate).map((k) => {
    let data = { ...dataOrigin[k] };
    Object.keys(dataUpdate[k]).map((r) => {
      data[r] = dataUpdate[k][r];
    });
    updateList.push(data);
  });
  // console.log("Data will update : ", updateList);

  if (dataNew.length > 0 || updateList.length > 0 || dataRemove.length > 0)
    return { new: dataNew, update: updateList, remove: dataRemove };
  return {};
}

export function getEditData(formData, loadFormData) {
  let keyArr = Object.keys(loadFormData);
  let editedData = {};

  for (let i = 0; i < keyArr.length; i++) {
    const key = keyArr[i];
    const val1 = formData[key];
    const val2 = loadFormData[key];

    const isArray = Array.isArray(val1) && Array.isArray(val2);
    const isDifferentArray =
      isArray && (val1.length !== val2.length || val1.some((v, j) => v !== val2[j]));

    if ((isArray && isDifferentArray) || (!isArray && val1 !== val2)) {
      if (val1 !== null) {
        editedData[key] = val1;
      }
    }
  }

  return editedData;
}
